import { mapGetters } from "vuex";
import TitleMappingUtil, { judgeThisKey } from '@/views/title_mapping/libs/util.js'
const ruleValid = (text) => (val) => !!val || val === 0 || text
const change_fields = [
    'expense_nature_id', 
    'customer_function_id', 
    'customer_type', // 员工类型
    'item_type_id',
    'fund_usage_id',
]
const illegality_val = ['', null, undefined]
export default {
  data() {
    return {
      change_fields: change_fields
    }
  },
  computed: {
    ...mapGetters('async', 
    [
      'income_bill_types', 
      'banks', 
      'currencies', 
      'account_leaf_titles', 
      'analysis_titles',
      'receipt_purposes',
      'expense_natures',
      'expense_natures_hash',
      'customer_functions',
      'mapping_customer_types',
      'item_types',
      'fund_usages',
      'title_mappings',
      'customer_functions_hash',
      'item_types_hash',
      'mapping_customer_types_hash',
      'fund_usages_hash'
    ]),
    // 费用个类型
    filter_expense_natures() {
      const filter_arr = this.change_fields.slice(0, this.change_fields.indexOf('expense_nature_id'))
      return this.commonFilter('expense_nature_id', 'expense_natures_hash', filter_arr);
    },
    // 员工职能
    filter_customer_functions() {
      const filter_arr = this.change_fields.slice(0, this.change_fields.indexOf('customer_function_id'))
        return this.commonFilter('customer_function_id', 'customer_functions_hash', filter_arr);
    },
    // 员工类型
    filter_customer_types() {
       const filter_arr = this.change_fields.slice(0, this.change_fields.indexOf('customer_type'))
        return this.commonFilter('customer_type', 'mapping_customer_types_hash', filter_arr);
      },
    // 产品类型
    filter_item_types() {
      const filter_arr = this.change_fields.slice(0, this.change_fields.indexOf('item_type_id'))
        return this.commonFilter('item_type_id', 'item_types_hash', filter_arr);
      }, 
    // 费用类型
    filter_fund_usages() {
        const filter_arr = this.change_fields.slice(0, this.change_fields.indexOf('fund_usage_id'))
        return this.commonFilter('fund_usage_id', 'fund_usages_hash', filter_arr);
    },
    mapped_expense_nature_hash() {
        return Object.assign({}, ...this.title_mappings.map(obj => {
          const key = obj['expense_nature_id'];
          return {[key]: true};
        }));
      },
    // 
    // 费用nature
    cost_nature_field() {
        const key = 'expense_nature_id'
        return {
          label: '费用nature',
          type:'autocompletes',
          key,
          items: this.filter_expense_natures,
          'item-disabled': this.expenseNatureDisabled,
          filter: this.expenseNatureFilter,
          'item-value':'id',
          'item-text':this.expenseNatureText, // 'name',
          // rules: [ ruleValid('费用nature必选') ],
          cols: 3,
          clearable: true,
          change: () => {
            this.calcAccountAndAnalysisTitle(key)
          }
        }
      },
        // 员工职能
      customer_function_field() {
        const key = 'customer_function_id'
        return {
            label: '员工职能',
            type:'autocompletes',
            key,
            items: this.filter_customer_functions,
            'item-value':'id',
            'item-text':(i) => (`${i.name}${i.del ? '(已废弃)' : ''}`),
            'item-disabled': 'del',
            placeholder: this.filter_customer_functions.length ? '请选择' : '无可选项',
            disabled:!this.filter_customer_functions.length,
            // rules: [ ruleValid('人员属性必选') ],
            cols: 3,
            clearable: true,
            change: () => {
                this.calcAccountAndAnalysisTitle(key)
            }
        }
      },
      customer_types_field() {
          const key = 'customer_type'
          return {
            label: '员工类型',
            type:'autocompletes',
            key,
            items: this.filter_customer_types,
            'item-value':'value',
            'item-text':'label',
            placeholder: this.filter_customer_types.length ? '请选择' : '无可选项',
            disabled: !this.filter_customer_types.length,
            // rules: [ ruleValid('员工类型必选') ],
            cols: 3,
            clearable: true,
            change: () => {
              this.calcAccountAndAnalysisTitle(key)
            }
          }
      },
      item_type_field() {
          const key = 'item_type_id'
          return {
              label: '产品类型',
              type:'autocompletes',
              key,
              items: this.filter_item_types,
              'item-disabled': 'del',
              'item-value':'id',
              'item-text':(i) => (`${i.name}${i.del ? '(已废弃)' : ''}`),
              placeholder: this.filter_item_types.length ? '请选择' : '无可选项',
              disabled: !this.filter_item_types.length,
              // rules: [ ruleValid('产品类型必选') ],
              cols: 3,
              clearable: true,
              change: () => {
                this.calcAccountAndAnalysisTitle(key)
              }
            }
      },
      fund_usage_field() {
          const key = 'fund_usage_id'
          return {
            label: '资金用途',
            type:'autocompletes',
            key,
            items: this.filter_fund_usages,
            'item-disabled': 'del',
            'item-value':'id',
            'item-text':(i) => (`${i.name}${i.del ? '(已废弃)' : ''}`),
            placeholder: this.filter_fund_usages.length ? '请选择' : '无可选项',
            disabled: !this.filter_fund_usages.length,
            // rules: [ ruleValid('产品类型必选') ],
            cols: 3,
            clearable: true,
            change: () => {
              this.calcAccountAndAnalysisTitle(key)
            }
          }
      },
      insider_trading_field() {
        return {
            label: '内部交易',
            type: 'checkbox',
            key: 'is_insider_trading',
            cols: 3,
            click: () => {
              this.calcAccountAndAnalysisTitle()
            }
        }
      },
      account_title_field_readonly() {
          return {
            label: '会计科目[自动匹配]',
            key:'account_title_id',
            type:'autocompletes',
            'item-value':'id',
            'item-text':({full_name}) => full_name,
            items: this.account_leaf_titles,
            required: true,
            readonly: true,
            cols: 6,
            rules: [ruleValid('会计科目必选')],
          }
      },
      account_title_field() {
       
        return {
            label: '会计科目',
            key:'account_title_id',
            type:'autocompletes',
            'item-value':'id',
            'item-text':({full_name}) => full_name,
            items: this.account_leaf_titles,
            required: true,
            cols: 6,
            rules: [ ruleValid('会计科目必选') ],
          }
      },
      analysis_title_field_readonly() {
          return {
            label: '分析科目[自动匹配]',
            key:'analysis_title_id',
            type:'autocompletes',
            'item-text': 'full_name',
            'item-value': 'id',
            items: this.analysis_titles,
            cols: 6,
            required: true,
            readonly: true,
            rules: [ ruleValid('分析科目必选') ],
          }
      },
      analysis_title_field() {
        return {
          label: '分析科目',
          key:'analysis_title_id',
          type:'autocompletes',
          'item-text': 'full_name',
          'item-value': 'id',
          items: this.analysis_titles,
          cols: 6,
          required: true,
          rules: [ ruleValid('分析科目必选') ],
        }
    },
      // 子单名称
      name_field() { 
          return {
            label: '子单名称',
            key:'name',
            type:'text_field',
            cols: 3,
            required: true,
            rules: [val => {
              return !!val || '单据名称必填'
            }]   
          }
      },
      team_field() {
          return {
            label: '费用承担团队',
            key:'team_id',
            type:'team_select',
            cols: 3,
            required: true,
            rules: [ ruleValid('费用承担团队必选') ],
          }
      },
      invoice_type_field() {
          return {
            label: '发票信息',
            key:'invoice_type',
            price_key: 'total_amount',
            type:'invoice_info_field',
            cols: 6,
            rules: [ ruleValid('发票信息必选') ]
          }
      },
      remark_field() {
          return {
            label: '备注',
            key:'remark',
            type:'textareas_field',
            cols: 12,
            counter: 500
          }
      }
  },
  methods: {
    commonFilter(id_key, hash_key, equal_keys = []) {
        const list = [];
        const pushed_ids = {};
        const hash = this[hash_key];
        for (const m of this.title_mappings) {
          const id = m[id_key];
          // if (id === 0) continue;
          if (this.isKeysEqual(m, equal_keys)) {
            if (!pushed_ids[id]) {
              pushed_ids[id] = true;
              const item = hash[id];
              if (item) {
                list.push(item);
              }
            }
          }
        }
        return list;
    },
    isKeysEqual(title_mapping, equal_keys = []) {
        const equal = true;
        for (const key of equal_keys) {
          if (judgeThisKey(this.expense, key) && title_mapping[key] !== this.expense[key]) {
            return false;
          }
        }
        return equal;
    },
    // 费用nature相关处理
    expenseNatureMapped(item) {
        return this.mapped_expense_nature_hash[item.id];
    },
    expenseNatureText(item) {
        let text = item.name;
        if (item.del) {
            text += '(已废弃)';
        } else if (!this.expenseNatureMapped(item)) {
            text += '(未建立 mapping 关系)';
        }
        return text;
    },
    expenseNatureDisabled(item) {
        return item.del || !this.expenseNatureMapped(item);
    },
    expenseNatureFilter(item, query_text) {
        const text = `${item.name} ${item.synonyms ? item.synonyms : ''}`;
        return text.includes(query_text);
    },
    // 通过费用nature、员工职能、员工类型、产品类型、资金用途、是否是内部交易来匹配分析与会计科目
    calcAccountAndAnalysisTitle(key) {
        if (key) {
           let index = this.change_fields.indexOf(key) + 1
           while (index && this.change_fields[index]) {
               this.expense[this.change_fields[index]] = null
               index++
           }
        }
        // 设置默认值
        const params = {}
        this.change_fields.forEach(item => {
          params[item] = this.expense[item] || 0
          if (item !== 'customer_type') {
            params[item] = this.expense[item] || 0
          } else if (item === 'customer_type' && illegality_val.includes(this.expense.customer_type)) { // 员工职能默认值是 -1
            params[item] = null
          }
        })
        this.expense.is_insider_trading = !!this.expense.is_insider_trading
        const title_mapping = TitleMappingUtil.getByNatureObj({...this.expense, ...params});
        this.expense.account_title_id = title_mapping.account_title_id;
        this.expense.analysis_title_id = title_mapping.analysis_title_id;
    },

  },
}
